"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = require("lodash");

var date_fns_1 = require("date-fns");

var criticalDocketEntryTypes_1 = __importDefault(require("./criticalDocketEntryTypes"));

function getLatestCriticalDocketEntry() {
  var docketEntries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    toString: true
  };
  // Find most recent troubling docket entry
  var criticalEntry = (0, lodash_1.orderBy)(docketEntries.filter(function (e) {
    return e.filedAt != null;
  }), ["filedAt"], ["desc"]).find(function (_ref) {
    var type = _ref.type;
    return criticalDocketEntryTypes_1.default.includes(type);
  }); // Return it formatted for request

  if (criticalEntry != null) {
    return options.toString === true ? "".concat((0, lodash_1.startCase)((0, lodash_1.snakeCase)(criticalEntry.type)), " (").concat(criticalEntry.filedAt == null ? "-" : (0, date_fns_1.format)(new Date(criticalEntry.filedAt), "M/d"), ")") : criticalEntry;
  }

  return null;
}

exports.default = getLatestCriticalDocketEntry;